import { clsx } from "clsx";

export const tableStyles = "border-collapse min-w-full text-ui";

export const getHeaderCellClassNames = ({
  sortable,
  disabled,
  isSelectionColumn,
}: {
  sortable?: boolean;
  disabled?: boolean;
  isSelectionColumn?: boolean;
}) => {
  const baseStyles = "border-neutral-100 font-inter font-semibold py-4";
  const hoverStyles = "hover:bg-neutral-50";
  const disabledStyles = "bg-white text-neutral-400";

  if (disabled) {
    return clsx(baseStyles, disabledStyles);
  }

  return clsx(
    baseStyles,
    sortable && hoverStyles,
    sortable && "cursor-pointer",
    !isSelectionColumn && "px-6",
    isSelectionColumn && "pl-6 pr-2 w-1",
  );
};

export const getDataRowClassNames = ({
  selected,
  clickable,
}: {
  selected?: boolean;
  clickable?: boolean;
}) => {
  const baseStyles = "hover:bg-cyan-40";
  const selectedStyles = "bg-cyan-40";
  const clickableStyles = "cursor-pointer";
  return clsx(
    baseStyles,
    selected && selectedStyles,
    clickable && clickableStyles,
  );
};

export const getDataCellClassNames = ({
  className,
  maxWidth,
  minWidth,
  width,
  action,
  selectable,
  loading,
  disabled,
}: {
  className?: string;
  maxWidth?: number;
  minWidth?: number;
  width?: number;
  action?: boolean;
  selectable?: boolean;
  loading?: boolean;
  disabled?: boolean;
}) => {
  const baseStyles = "border-neutral-100 border-t p-0";
  const actionStyles = "overflow-hidden text-ellipsis whitespace-nowrap";
  const disabledStyles = "bg-white text-neutral-400";

  if (disabled) {
    return clsx(baseStyles, disabledStyles);
  }

  return clsx(
    baseStyles,
    action && actionStyles,
    action && selectable && "cursor-pointer",
    maxWidth && `max-w-[${maxWidth}px]`,
    loading && minWidth && `min-w-[${minWidth}px]`,
    !loading && width && `w-[${width}px]`,
    className,
  );
};

export const getCellWrapperClassNames = ({
  selected,
  isSelectionColumn,
}: {
  selected?: boolean;
  isSelectionColumn?: boolean;
}) => {
  const baseStyles = "w-full h-full py-4";

  return clsx(
    baseStyles,
    selected && "border-l-[2px] border-blue-560",
    !isSelectionColumn && "px-6",
    isSelectionColumn && "pl-6 pr-2",
  );
};

export const getHeaderCellWrapperClassNames = () => {
  const baseStyles = "overflow-hidden text-ellipsis whitespace-nowrap";

  return clsx(baseStyles);
};

export const getHeaderCellContainerClassNames = ({
  isSelectionColumn,
}: {
  isSelectionColumn?: boolean;
}) => {
  const baseStyles = "flex items-center gap-small w-full";

  return clsx(baseStyles, isSelectionColumn && "justify-center");
};
